import React, { useEffect, useState } from 'react';
import { XMarkIcon } from '@heroicons/react/24/solid';

import { ConnectedAccounts } from '#/app/dashboard/account/connected-accounts/components/ConnectedAccounts';
import { getUser } from '#/hooks/getUser';
import { useFlowContext } from '#/providers/FlowContext';

import LoadingIndicator from '~/ui/LoadingIndicator';

export default function AuthModal() {
  const [user, setUser] = useState();
  async function refreshUser() {
    setUser(await getUser());
  }
  useEffect(() => {
    refreshUser();
  }, []);

  const isLoading = user == null;

  const { setCanDeleteNode, setIsAuthModalShown, unmetPrerequisites } =
    useFlowContext();

  const handleClickClose = () => {
    setCanDeleteNode(true);
    setIsAuthModalShown(false);
  };

  return (
    <div className="opacity-100 absolute z-[100] h-full w-full pointer-events-auto backdrop-blur-sm flex items-center justify-center p-8">
      <div className="data-[state=open]:animate-overlayShow bg-[url('/grid.svg')] overflow-y-scroll data-[state=open]:animate-contentShow fixed top-[50%] left-[50%] translate-x-[-50%] translate-y-[-50%] border bg-black bg-opacity-85 shadow-[hsl(206_22%_7%_/_35%)_0px_10px_38px_-10px,_hsl(206_22%_7%_/_20%)_0px_10px_20px_-15px] focus:outline-none shadow-widget h-full w-full max-w-[800px] max-h-[500px] rounded-lg flex flex-col items-center justify-start gap-8 p-4">
        <div className="absolute top-4 right-4 z-[110]">
          <label
            tabIndex={0}
            onClick={handleClickClose}
            className={
              'pointer-events-auto btn btn-sm border-0 hover:border-2 hover:border-secondary btn-circle'
            }
          >
            <XMarkIcon className="h-5 w-5" />
          </label>
        </div>
        <div className="menuBody md:py-4 flex flex-col space-y-1 text-primary">
          <h1 className="text-xl font-semibold">Connected Accounts</h1>
          <p className="text-lg text-gray-300">
            You must authenticate before you continue.
          </p>
          {/* <p className="text-md">
            {`Workflow failed pre-flight checks. Unmet prerequisites: ${unmetPrerequisites
              .map((p) => `[${p.nodeLabel}: ${p.prerequisite}] ${p.message}`)
              .join(', ')}`}
          </p> */}
        </div>
        {isLoading ? <LoadingIndicator /> : <ConnectedAccounts user={user} />}
      </div>
    </div>
  );
}
